// @flow

// Constants
import {
  TREE,
} from '../constants'

import traverse from 'fc-utils/traverse'

export default (traverse([TREE, 'tableOperation']))
